var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-gray-400 text-xs"},[(_vm.invite.isRevoked())?_c('p',[_c('i',{staticClass:"fas fa-times mr-1"}),_vm._v(" "),_c('span',{},[_vm._v("Revoked")])]):(_vm.invite.isViewed())?_c('p',[_c('i',{staticClass:"far fa-eye mr-1"}),_vm._v(" "),_c('span',{},[_vm._v("Viewed")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }